import "../../../styles/stores/advertisement/advertisement.css";
import { FiPlus } from "react-icons/fi";
import { BsClock } from "react-icons/bs";
import InitialAdState from "./InitialAdState";
import CreateAd from "./CreateAd";
import { useState, useEffect } from "react";
import AdComponent from "./AdComponent";
import { getStoreAdUrl, getStoreUrl } from "../../../api/endpoints";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/uxCollections/Loaders";
import { ModalAlert } from "../../../components/alerts/modalAlert";
import { refreshUserToken } from "../../../tools/refreshToken";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const AdvertismentHomePage = () => {
  const [hasAd, setHasAd] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [runningAd, setRunningAd] = useState();
  const [expiredAd, setExpiredAd] = useState([]);
  const [isLoading, setIsLoading] = useState(true); //
  const [alertDisplay, setAlertDisplay] = useState({
    showAlert: false,
    type: "",
    title: "",
    message: "",
  });
  const { store } = useSelector((state) => state.store);
  const userCurrency = useSelector((state) => state.webStoreUser.user.userCountryCurrencySymbol);
  const navigate = useNavigate();

  useEffect(() => {
    getAd();
  }, []);

  const getAd = async () => {
    try {
      console.log(localStorage.getItem("accessToken"));
      const response = await fetch(getStoreAdUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        data.length === 0 ? setHasAd(false) : setHasAd(true);
        if (data.length > 0) {
          let runningAd = data.filter((ad) => ad.status === "active");
          let expiredAd = data.filter((ad) => ad.status === "expired");
          runningAd.length > 0 ? setRunningAd(runningAd[0]) : setRunningAd(expiredAd[0]);
          setExpiredAd(expiredAd);
        }
        console.log(data);
        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(getStoreAdUrl + store._id, getAd, navigate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='headlinelineAdvert'>
        <p>Running ads</p>
        <div>
          <BsClock />
        </div>
      </div>

      <div className='advertWrapperMainDiv'>
        {hasAd ? (
          <AdComponent
            runningAd={runningAd}
            expiredAd={expiredAd}
            storeID={store._id}
            updateRunningAd={setRunningAd}
            updateExpiredAd={setExpiredAd}
            setAlertDisplay={setAlertDisplay}
          />
        ) : (
          <InitialAdState />
        )}
        {isLoading && <Spinner position={"absolute"} backgroundColor={"#F9F9F9"} />}
      </div>

      <div className='createAdButtonDiv'>
        {runningAd && runningAd.status === "active" ? (
          <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='createAdButton'>
            {" "}
            <FiPlus size={30} /> Create Ad
          </button>
        ) : (
          <button
            className='createAdButton'
            onClick={() => {
              uiAlert("This feature is not available at the moment. Please contact support for more information.", "info");
              return;
              setShowModal(true);
            }}
          >
            {" "}
            <FiPlus size={30} /> Create Ad
          </button>
        )}
      </div>

      {showModal && (
        <CreateAd
          closeModal={setShowModal}
          updateHasAd={setHasAd}
          updateRunningAd={setRunningAd}
          updateExpiredAd={setExpiredAd}
          setAlertDisplay={setAlertDisplay}
          userCurrency={userCurrency}
        />
      )}
      <ModalAlert
        type={alertDisplay.type}
        showAlert={alertDisplay.showAlert}
        title={alertDisplay.title}
        message={alertDisplay.message}
        setAlertDisplay={setAlertDisplay}
      />
    </>
  );
};

export default AdvertismentHomePage;
